import { makeVar } from '@apollo/client'

export const rvOnboardingTutorialImages = makeVar<
  Record<string, HTMLImageElement>
>({})
